interface Message {
  role: 'user' | 'assistant' | 'system';
  content: string;
}

const DEEPSEEK_API_URL = 'https://api.deepseek.com/v1/chat/completions';
const DEEPSEEK_API_KEY = import.meta.env.VITE_DEEPSEEK_API_KEY;

// Sistema de prompts mejorado
const SYSTEM_PROMPT = `Eres un asistente virtual especializado en las soluciones de Automata AI. Sigue estas directrices estrictas:

REGLAS DE RESPUESTA:
1. LONGITUD: Máximo 3 oraciones por respuesta
2. TONO: Profesional y directo
3. CONTENIDO: Solo información sobre Automata AI y sus servicios
4. PRECISIÓN: Sin especulaciones ni información no verificada

SERVICIOS A MENCIONAR:
- Prueba de concepto (POC): 30-60 días
- Implementación empresarial personalizada
- Integraciones con sistemas existentes
- Soporte 24/7
- Análisis y reportes detallados

ÁREAS DE ESPECIALIZACIÓN:
- Chatbots para atención al cliente
- Automatización de procesos empresariales
- Análisis de sentimientos
- Integración multicanal
- IA personalizada para empresas

SI NO SABES ALGO:
- Responde: "Para obtener información más detallada sobre [tema], te sugiero agendar una llamada con nuestro equipo."
- NO inventes información
- NO menciones servicios o características que no ofrecemos

EJEMPLOS DE RESPUESTAS CORRECTAS:
Usuario: "¿Cuánto cuesta?"
Respuesta: "Ofrecemos planes personalizados según las necesidades de tu empresa. Te invito a agendar una llamada con nuestro equipo para discutir tu caso específico."

Usuario: "¿Cómo funciona el POC?"
Respuesta: "Nuestro POC es un programa de 30-60 días donde implementamos la solución en un área específica de tu negocio. Incluye configuración personalizada, entrenamiento y evaluación de resultados."`;

// Manejo de contexto de conversación
let conversationContext: Message[] = [];

export const generateResponse = async (message: string): Promise<string> => {
  try {
    // Mantener un contexto limitado de la conversación
    if (conversationContext.length > 10) {
      conversationContext = conversationContext.slice(-10);
    }

    // Añadir el mensaje actual al contexto
    conversationContext.push({
      role: 'user',
      content: message
    });

    const response = await fetch(DEEPSEEK_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${DEEPSEEK_API_KEY}`,
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        model: 'deepseek-chat',
        messages: [
          {
            role: 'system',
            content: SYSTEM_PROMPT
          },
          ...conversationContext
        ],
        max_tokens: 1000,
        n: 1,
        temperature: 0.7,
        stream: false
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error('API Error:', {
        status: response.status,
        statusText: response.statusText,
        errorData
      });
      throw new Error(`API request failed with status ${response.status}`);
    }

    const data = await response.json();
    const assistantResponse = data.choices[0].message.content;

    // Añadir la respuesta del asistente al contexto
    conversationContext.push({
      role: 'assistant',
      content: assistantResponse
    });

    return assistantResponse;
  } catch (error) {
    console.error('Error generating response:', error);
    throw new Error('Lo siento, hubo un error al procesar tu mensaje. Por favor, inténtalo de nuevo.');
  }
}; 